<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                  <sidebar></sidebar>
                </el-aside>
                <el-main>
                   <div class="tips" v-if="isTag == true">您还没有完成资质审核，还不能发布产品等其他信息，请先完成资质审核</div>
                   <contTitle  :class="[isTag ==true ?'m-t-30':'' ]" :obj="obj" :contTitle="contTitle"></contTitle>
                   <companySide class="mt-20" :isButton="isButton" @release="gorelease()"></companySide> 
                   <div class="mt-30">
                      <contTitle :obj="obj" :contTitle="contTitles"></contTitle>
                       <div class="mt-30 info_form">
                           <el-form ref="form" :rules="rules" :label-position="labelPosition" :model="form" label-width="100px">
                               <el-form-item label="资讯标题 :" prop="title" style="width: 60%;">
                                    <el-input v-model="form.title" clearable></el-input>
                                </el-form-item>
                                 <el-form-item label="资讯类别 :" prop="type">
                                     <el-cascader :options="categoryList"  :props="optionProps" v-model="form.type" :show-all-levels="false"  @change="onChang()" style="width:53%;"></el-cascader>
                                </el-form-item>
                                 <p class="case_tig">图片信息，上传图片的格式为，289*162px，1M以内</p>
                                <el-form-item class="poster" prop="cover"   label="资讯海报 :" style="width: 60%;">
                                   <el-input v-model="form.cover" clearable></el-input>
                                    <el-upload
                                    class="upload-demo"
                                    :headers="{token:token}"
                                    action="/api/zwb/app/oss/public/upload"
                                    :on-success="onSuccess"
                                    :show-file-list="false"
                                    :before-upload="handlePictureCardPreview">
                                    <el-button class="posterBtn" type="primary">选择图片</el-button>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="关键字 ："  style="width: 60%;">
                                    <el-input v-model="form.keyWord" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="资讯描述：" prop="description"  style="width: 60%;">
                                    <el-input type="textarea" v-model="form.description" clearable></el-input>
                                </el-form-item>
                                <div class="tel">
                                    <p class="text_center">详情介绍</p>
                                    <tinymceEditor class="mt-15" v-model="form.content" ref="editor"></tinymceEditor>
                                </div>
                                <div class="tel mt-20">
                                    <el-switch v-model="form.syncStatus" :active-value="1"  :inactive-value="0"  active-text="是否同步到首页"></el-switch>
                                </div>
                                <div class="tel mt-30">
                                    <el-button type="success" @click="submitForm('form')">提交资讯</el-button>
                                </div>
                           </el-form>
                       </div>
                   </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {getDict} from "@/api/coment";
import {getToken} from '@/utils/auth'
import {addIndustryinfo,industryinfoDetail,editIndustryinfo} from "@/api/company"
import {getIndustryinfoById} from "@/api/information"
import sidebar from '../../common/sidebar'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import paletteBar from '../../common/paletteBar'
import contTitle from '../../common/contTitle'
import tinymceEditor from '../../common/tinymceEditor.vue'
export default {
  components:{
      sidebar,companySide,commBanner,titleHead,paletteBar,contTitle,tinymceEditor
  }, 
  data(){
      return{
        headTitle:'企业资讯',
        contTitle:'企业基本信息',
        contTitles:'添加资讯',
        obj:{
           title:'企业资讯',   
           isShow:false,
           isColor:false,
           roleType:3,
           personalType:9
        },		
        form:{
            title:'',
            type:'',
            cover:'', //海报
            content:'', //内容
            description:'', //描述
            syncStatus:0,
        },
        rules:{
            title:[
              { required: true, message: '请输入资讯标题', trigger: 'blur' },
            ],
            type:[
                { required: true, message: '请选择资讯类别', trigger: 'change' }
            ],
            cover:[{ required: true, message: '请上传资讯海报', trigger: 'change' },],
            description:[
              { required: true, message: '请输入详情介绍', trigger: 'blur' },
            ]
        },
        labelPosition:'left',
        categoryList:[],//行业类别
        optionProps:{
          value: 'id',
          label: 'name',
          children: 'children'
        },
        industry_type:"",
        token:getToken(),
        isButton:false,
        isTag:true
      }
  },
  created(){
      this.getCailter();
      let status = this.$store.state.user.userInfo.data.status;
      if(status == 1){
        this.isTag = false;
      }
      if(this.$route.query.id){
        this.id = this.$route.query.id;
        this.getExampleInfo(this.id); 
	   }
  },
  methods:{
      //查询资讯详情
      getExampleInfo(id){
        getIndustryinfoById(id).then((res)=>{
          if(res.code == 0){
            this.form = res.data;
          }
        }).catch((err)=>{})
      },
      //提交资讯
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.id){
              editIndustryinfo(this.form).then(res=>{
               if(res.code ==0){
                  this.$message({
                    message:'提交成功！',
                    type: 'success',
                     duration:1000,
                    onClose:()=>{
                        this.$router.push('/corporate_list')
                     }
                  }); 
                }
              }).catch((err)=>{})
            }else{
              addIndustryinfo(this.form).then(res=>{
                if(res.code ==0){
                  this.$message({
                    message:'添加成功！',
                    type: 'success',
                     duration:1000,
                    onClose:()=>{
                        this.$router.push('/corporate_list')
                     }
                  }); 
                }
              }).catch(err=>{});
            }
          } else {
            return false;
          }
        });
      },
      //行业类别
     getCailter(){
      let params={
         code:this.industry_type
       }
       getDict(params).then(res=>{
         if(res.code ==0){
           this.categoryList = res.data[0].children;
         }
       }).catch(err=>{});
     },
      //文件上传成功后，返回
      onSuccess(res){
          if(res.code ==0){
            this.$message({
              message:'上传成功！',
              type: 'success',
            });
           this.form.cover = res.url;
         }
      },
     //文件上传前，调用
      handlePictureCardPreview(file){
        const isLtM = file.size / 1024 / 1024 < 3;
            if(!isLtM){
            this.$message.error('上传文件大小不能超过 3MB!');
            }
        return isLtM;
      },
	   //选中
	   onChang(){
		  this.form.type = this.form.type.pop();
	   },
	  //发布需求
	  gorelease(){
		this.$router.push('/demand')  
	  }
  },
}
</script>
<style scoped>
.el-aside{
    height:100%;
}
.el-form-item{
    text-align: left;
}
.tel{
    text-align: left;
}
.mt-15{
    margin-top: 15px;
}
.m-t-30{
    margin-top: 30px;
}
.mt-20{
    margin-top: 20px;
}
.tips{
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #E28B8B; 
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
.info_form>>>.el-input__inner{
    height: 50px;
}
.poster{
  position: relative;
}
 /deep/ .upload-demo{
     position: absolute;
     top: 0;
     right: 0;   
 }
.posterBtn{
     width: 125px;
     height: 50px;
     background: #E5E5E5;   
     font-size: 12px;
     font-family: Microsoft YaHei;
     font-weight: 400;
     color: #9A9A9A;
     border: none;
     line-height: 0;
 }
.tel>>> .el-button--primary:hover{
  background: #E5E5E5;
  color: #9A9A9A;
}
 /deep/.el-button--success{
     width: 114px;
     height: 40px;
     background: #3CBB36;
     border-radius: 3px;
     border: none;
     line-height: 0;
 }
  /deep/.el-button--warning{
    width: 114px;
    height: 40px;
    background: #FF7302;
    border-radius: 3px;
    border: none;
    line-height: 0;
 }
 /deep/.el-button--primary:hover{
    background: #E5E5E5;   
 }
 .text_center{	
	font-size: 14px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #333333;
}
.case_tig{
  text-align:left;
  margin-bottom: 15px;
  font-size: 12px;
  color: #999999;
}

.info_form>>>.el-switch.is-checked .el-switch__core{
   border-color: #3BAE30;
   background-color: #3BAE30;
}
.info_form>>>.el-switch__label.is-active{
  color: #3BAE30;
}
.info_form>>>.el-textarea__inner{
   height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/view/company/corporate_owned.vue